export const getTaskStatusIdElement = (taskId) => {
    return document.SubmitTTForm.elements["taskStatuses[" + taskId + "].id"]
}

export const getTaskStatusNameElement = (taskId) => {
    return document.SubmitTTForm.elements["taskStatuses[" + taskId + "].name"]
}

export const getTaskStatusModifiedElement = (taskId) => {
    return document.SubmitTTForm.elements["taskStatuses[" + taskId + "].modified"]
}



// WEBPACK FOOTER //
// ./web/js/user/entertt/utils.js